document.addEventListener( 'DOMContentLoaded', event => {

	// photoslurp

	document.querySelectorAll('.ps-image').forEach( li => {
		li.addEventListener( 'click', e => gtag('event', 'click_photoslurp') );
	} );

	document.querySelectorAll('.ps-prev, .ps-next').forEach( span => {
		span.addEventListener( 'click', e => gtag('event', 'scroll_photoslurp') );
	} );


	// press

	document.querySelectorAll('.section-partners-opinions-rocket__partners__logo__image').forEach( div => {
		div.addEventListener( 'click', e => gtag('event', 'click_press') );
	} );


	// product

	document.querySelectorAll('.swatches-rocket__list__li__link').forEach( a => {
		a.addEventListener( 'click', e => gtag('event', 'click_bubble') );
	} );

	document.querySelectorAll('.section-caracteristicas-destacadas .owl-prev, .section-caracteristicas-destacadas .owl-next').forEach( button => {
		button.addEventListener( 'click', e => gtag('event', 'scroll_product-features') );
	} );

	document.querySelectorAll('.section-seo-description details').forEach( details => {
		details.addEventListener( 'toggle', e => {
			if (e.currentTarget.open) gtag('event', 'open_product-faq');
		} );
	} );


	// trustpilot

	document.querySelectorAll('.tp-widget-review').forEach( div => {
		div.addEventListener( 'click', e => gtag('event', 'click_trustpilot') );
	} );

	document.querySelectorAll('#review-arrow-left, #review-arrow-right').forEach( div => {
		div.addEventListener( 'click', e => gtag('event', 'scroll_trustpilot') );
	} );


	// country selector

	document.querySelectorAll('#country-list-footer .disclosure-list__option').forEach( a => {
		a.addEventListener( 'click', e => {
			gtag( 'event', 'select_country', { iso_code: a.dataset.value } );
		} );
	} );

} );